import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type Transition from '@ember/routing/transition';

export default class AuthenticatedAdminPeopleShowRoute extends Route {
  @service declare router: RouterService;
  // TODO: temporarily redirect to the employee route until the admin people route is implemented
  beforeModel(transition: Transition) {
    this.router.transitionTo(
      'authenticated.admin.employees.show',
      transition.to?.params?.person_id
    );
  }
}
